<template>
  <div class="downloadView">
    <div class="title">
      <div class="subtitle titleH2">MPai数据科学平台：</div>
      <div class="subtitle" style="color: #787878;">开启数据科学极致体验</div>
    </div>
    <div style="font-size: larger;font-weight:bolder;color:#FB9100">点击下方下载</div>
    <row type="flex">
      <i-col span="6" class="context"></i-col>
      
      <i-col span="12" class="context">
        
        <div class="imgIcon">
          <span class="title" @click="clickDownLoad(window_main_downLoad_url)">
            <h2>Windows</h2>
            <Icon class="titleIcon" type="logo-windows" />
          </span>
        </div>
      </i-col>
      <i-col span="6" class="context"></i-col>
      <!-- <i-col span="12" class="context">
        <div class="imgIcon">
          <span
            class="title iosBg"
            @click="clickDownLoad(os_main_downLoad_url)"
          >
            <h2>MacOS</h2>
            <i class="icon-mpai-pingguo1 titleIcon"></i>
          </span>
        </div>
      </i-col> -->
    </row>
    <row type="flex">
      <i-col span="6" class="context"></i-col>
      <i-col span="12" class="context">
        <div class="imgIconTitle">
          <div class="centerLayout">
            <!-- <div class="titlecont aStyle">
              <div>正式版：</div>
              <div
                class="sapn_a"
                @click="clickDownLoad(window_official_downLoad_url)"
              >
                V1.0
                <Icon class="loadIcon" type="md-cloud-download" />
              </div>
            </div> -->
            <div>目前只支持win7sp以上，完美适配win10</div>
          </div>
        </div>
      </i-col>
      <i-col span="6" class="context"></i-col>
      <!-- <i-col span="12" class="context">
        <div class="imgIconTitle">
          <div class="centerLayout">
            <div class="titlecont">
              <div class="aStyle">正式版：</div>
              <div
                class="aStyle sapn_a"
                @click="clickDownLoad(os_official_downLoad_url)"
              >
                预计10月份中旬推出
                <Icon class="loadIcon" type="md-cloud-download" />
              </div>
            </div>
          </div>
        </div>
      </i-col> -->
    </row>
    <div class="imgStyleContext downloadTips">
      为了获取更好的用户体验，我们建议您使用<span class="downloadTips_bold"
        >火狐</span
      >或<span class="downloadTips_bold">谷歌浏览器</span>访问本系统！
    </div>
    <div class="imgStyleContext downloadTips">
      欢迎大家加入
      <span class="downloadTips_bold">交流群</span>
      ，提出
      <span class="downloadTips_bold">BUG</span>
      或
      <span class="downloadTips_bold">建议</span>
      ！
      <span class="downloadTips_bold_qq">开发者QQ：210681676</span>
      <!-- <span>（用于拉进群）</span> -->
    </div>

    <div class="imgStyleContext">
      <img src="static/image/img-download-pc.png" class="imgStyle" />
    </div>
    <!-- <div class="textStyleContext">
      <div class="centerText">
        <Icon type="md-color-wand" />
        产品简介
      </div>
    </div> -->
    <div class="textStyleContext">
      <div class="textStyle">
        MPai是一款本地的网页版数据科学算法平台工具
      </div>
    </div>
    <div class="textStyleContext">
      <div class="textStyle">
        为您提供低门槛数据科学的极致体验
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    clickDownLoad(url) {
      if (url === "#") {
        this.$Message.info("暂不开放，敬请期待！");
      } else {
        try {
          if (
            localStorage.getItem("userMsg") !== "{}" &&
            localStorage.getItem("userMsg") !== null
          ) {
            window.location.href = url;
          } else {
            this.$Message.info("请登录后再下载");
            this.$store.dispatch("commitIsShow", true);
            this.$store.dispatch("commitActiveName", "login");
          }
        } catch (error) {
          this.$Message.info("请登录后再下载");
          this.$store.dispatch("commitIsShow", true);
          this.$store.dispatch("commitActiveName", "login");
        }
      }
    }
  },
  data() {
    return {
      window_downLoad_url: this.$GLOBAL.WINDOW_DOWNLOAD_URL,
      window_official_downLoad_url: this.$GLOBAL.WINDOW_OFFICIAL_DOWNLOAD_URL,
      window_main_downLoad_url: this.$GLOBAL.WINDOW_MIAN_DOWNLOAD_URL,
      os_downLoad_url: this.$GLOBAL.OS_DOWNLOAD_URL,
      os_official_downLoad_url: this.$GLOBAL.OS_OFFICIAL_DOWNLOAD_URL,
      os_main_downLoad_url: this.$GLOBAL.OS_MIAN_DOWNLOAD_URL
    };
  }
};
</script>
<style lang="less" scoped>
* {
  user-select: none;
}
.aStyle > a {
  color: #c5c8ce;
}
.aStyle > a:hover {
  color: #c5c8ce;
}
.titleIcon {
  font-size: 50px;
  margin-left: 10px;
}
.textStyleContext {
  width: 100%;
  display: flex;
  justify-content: center;
  .centerText {
    user-select: text;
    color: #2b85e4;
    font-size: 16px;
    padding: 5px 0;
  }
  .textStyle {
    user-select: text;
    font-size: 20px;
    text-align: center;
    padding: 5px 0;
    width: 60%;
    min-width: 760px;
    font-family: "华文仿宋";
    font-weight: bold;
  }
}
.subtitle {
  font-size: 40px;
  font-weight: bolder;
}
.downloadView {
  padding: 20px 5vw;
  padding-bottom: 40px;
  text-align: center;
  .title {
    font-weight: bold;
    font-size: 24px;
    padding: 35px 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 2px;
    .titleH2 {
      color: black;
    }
  }
  .context {
    display: flex;
    align-items: center;
    justify-content: center;
    .imgIcon {
      min-height: 200px;
      min-width: 320px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .title {
        letter-spacing: 3px;
        min-width: 320px;
        width: 70%;
        height: 100%;
        min-height: 160px;
        max-height: 200px;
        cursor: pointer;
        color: #ffffff;
        background: linear-gradient(
          90deg,
          rgba(0, 50, 247, 1) 0%,
          rgba(0, 133, 254, 1) 100%
        );
        translate: all 0.3s ease-in-out;
      }
      .title:hover {
        background: linear-gradient(
          90deg,
          rgba(0, 133, 254, 1) 100%,
          rgba(0, 50, 247, 1) 0%
        );
      }
      .iosBg {
        letter-spacing: 3px;
        min-width: 320px;
        width: 70%;
        height: 100%;
        min-height: 165px;
        max-height: 200px;
        background-image: linear-gradient(60deg, #29323c 0%, #485563 100%);
      }
      .iosBg:hover {
        background-image: linear-gradient(
          to top,
          #c4c5c7 0%,
          #dcdddf 52%,
          #ebebeb 100%
        );
        color: #29323c;
      }
    }
    .imgIconTitle {
      margin: 5px 6vw;
      min-width: 320px;
      width: 100%;
      font-size: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      .centerLayout {
        text-align: center;
        .titlecont {
          display: flex;
          justify-content: center;
          padding: 3px 30px;
          .sapn_a {
            color: #787878;
          }
          .sapn_a:hover {
            color: #2b85e4;
          }
          .sapn_a:hover > .loadIcon {
            visibility: inherit;
          }
          .loadIcon {
            visibility: hidden;
          }
        }
      }
    }
    @media screen and (max-width: 1380px) {
      .imgIconTitle {
        font-size: 14px !important;
      }
    }
  }
}

@media screen and (max-width: 990px) {
  .subtitle {
    font-size: 35px;
    font-weight: bolder;
  }
}

.imgStyleContext {
  width: 100%;
  text-align: center;
  .imgStyle {
    width: 50%;
    padding: 40px 0;
  }
}
.downloadTips {
  user-select: text;
  font-size: 16px;
  padding-top: 10px;
  .downloadTips_bold {
    user-select: text;
    font-weight: bold;
    color: black;
  }
  .downloadTips_bold_red {
    user-select: text;
    font-weight: bold;
    color: #ff9900;
  }
  .downloadTips_bold_green {
    user-select: text;
    font-weight: bold;
    color: #19be6b;
  }
  .downloadTips_bold_qq {
    user-select: text;
    font-weight: bold;
    color: black;
    font-size: 20px;
  }
}
</style>
